import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance30 = () => {
  return <IndividualTable matchType={"4"} gender="M" event="30" subTitle="Zamby" data={sampleData} topRankCount="2" winners={["428", "312"]} />;
};
export default Distance30;
